import { Transforms, Editor, Text } from 'slate';
import { createTokenElement, isDefaultBlockTypeElement } from '../utilities.mjs';
import { elementIsEmpty } from '../queries/elementIsEmpty.mjs';

function insertToken(editor, {
  at,
  data,
  select = false,
  tokenSerializedValue,
  defaultBlockType
}) {
  const range = getRange(editor, at);
  if (data.block) {
    insertBlockToken(editor, range, {
      data,
      tokenSerializedValue,
      defaultBlockType
    });
  } else {
    insertInlineToken(editor, range, data);
  }
  if (!select) {
    Transforms.move(editor, {
      distance: 1
    });
  }
}
function insertInlineToken(editor, at, data) {
  Transforms.insertNodes(editor, createTokenElement(data), {
    at,
    select: true
  });
}
function insertBlockToken(editor, at, {
  data,
  tokenSerializedValue,
  defaultBlockType
}) {
  var _Editor$above, _Editor$node;
  const range = getRange(editor, at);
  const [ancestorNode] = (_Editor$above = Editor.above(editor, {
    at: range
  })) != null ? _Editor$above : [];
  const isAncestorEmptyDefaultBlockType = ancestorNode && isDefaultBlockTypeElement(ancestorNode, defaultBlockType) && elementIsEmpty(ancestorNode);
  const [nodeAt, nodeAtPath] = (_Editor$node = Editor.node(editor, range)) != null ? _Editor$node : [];
  const isManuallyInputtedBlockToken = Text.isText(nodeAt) && nodeAt.text === tokenSerializedValue;
  if (isAncestorEmptyDefaultBlockType || isManuallyInputtedBlockToken) {
    Editor.withoutNormalizing(editor, () => {
      if (isManuallyInputtedBlockToken) {
        // Reset the value of the text node that exclusively contains serialized value
        Transforms.insertText(editor, '', {
          at: nodeAtPath
        });
      }
      Transforms.setNodes(editor, createTokenElement(data), {
        at: range
      });
    });
    return;
  }
  Editor.withoutNormalizing(editor, () => {
    const rangeRef = Editor.rangeRef(editor, getRange(editor, at), {
      affinity: 'forward'
    });
    if (rangeRef.current) {
      Transforms.splitNodes(editor, {
        at: rangeRef.current
      });
      Transforms.insertNodes(editor, createTokenElement(data), {
        at: rangeRef.current,
        select: true
      });
      rangeRef.unref();
    }
  });
}
function getRange(editor, at) {
  let range = at;
  if (!range) {
    const point = Editor.end(editor, []);
    range = {
      anchor: point,
      focus: point
    };
  }
  return range;
}

export { insertToken };
